<form class="itinerary-model-content-inner" [formGroup]="hotelPricingForm">
  <div class="itinerary-model-content">
    <div class="ion-no-padding">
      <div class="ion-padding-horizontal py-1 bg-light-gray d-flex justify-content-between">
        <ion-title class="dark-title-sm ion-no-padding">Hotel Pricing</ion-title>
        <div>
          <div class="currency-container">
            <label class="label">Currency
              <!-- TODO: use lov here -->
              <select class="input" formControlName="currency">
                <option value="INR">INR</option>
                <option value="USD">USD</option>
                <option value="EURO">EURO</option>
                <option value="SGD">SGD</option>
                <option value="THB">THB</option>
              </select>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="form-container ion-padding-horizontal">
      <div>
        <div class="">
          <ng-container formArrayName="packages">
            <div class="mt-1 package-main-container" *ngFor="let package of getPackagesFormArray().controls; index as packageIndex" [formGroupName]="packageIndex">
              <div class="package-title-container p-1">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <p class="package-index">Package {{packageIndex+1}}</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <label for="" class="category-label fw-bold me-3">Hotel Category*</label>
                    <div class="d-flex align-items-center">
                      <div class="input-container">
                        <div [ngClass]="{ 'invalid-input': package.get('hotelCategory')?.invalid && package.get('hotelCategory')?.touched }">
                          <app-dropdown-select [dropdownValues]="hotelCategoryLov" formControlName="hotelCategory"></app-dropdown-select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <ion-button fill="clear" size="small">
                      <ion-icon slot="icon-only" name="chevron-down-circle-outline"></ion-icon>
                    </ion-button>
                  </div>
                </div>
              </div>


              <!-- Package table container -->
              <div class="pricing-table-container">
                <table class="pricing-table locations-table">
                  <thead>
                    <tr>
                      <th rowspan="2" style="min-width: 160px;">Location/Hotel</th>
                      <th rowspan="2" style="width: 50px;">Nights</th>
                      <th rowspan="2" style="width: 140px; border-right: 0;">Meal Plan</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container formArrayName="locations">
                      <tr *ngFor="let location of getLocationsFormArray(packageIndex).controls;index as locationIndex" [formGroupName]="locationIndex">
                        <td>
                          <div class="location-item">
                            <div class="location">
                              <p class="name">{{location.get('locationName')?.value}}</p>
                            </div>
                            <div class="hotel input-container">
                              <label for="" class="hotel-label">Enter Hotel Name</label>
                              <div [ngClass]="{ 'invalid-input': location.get('hotelName')?.invalid && location.get('hotelName')?.touched }">
                                <input type="text" class="input hotel-input" placeholder="Hotel Name" formControlName="hotelName">
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="text-center">{{location.get('nights')?.value}}</td>
                        <td>
                          <app-meal-plan-input [flexColumn]="true" [items]="meals" [selectAllKey]="MEAL_PLAN.ALL_INCLUSION" formControlName="mealPlan"></app-meal-plan-input>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>

                <table class="pricing-table pax-table">
                  <thead>
                    <tr>
                      <th rowspan="2" style="width: 60px;">Pax Count*</th>
                      <th rowspan="2" style="width: 70px;">Land Cost*</th>
                      <th colspan="3">Occupancy <span style="font-size: 70%;">(Fill atleast 1 value)</span></th>
                      <th rowspan="2" style="width: 70px;">Child with Bed</th>
                      <th rowspan="2" style="width: 80px;">Extra Child without Bed</th>
                      <th rowspan="2" style="width: 30px;"></th>
                    </tr>
                    <tr>
                      <th style="width: 70px;">SGL</th>
                      <th style="width: 70px;">DBL</th>
                      <th style="width: 70px;">TPL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container formArrayName="occupancyPricings">
                      <tr *ngFor="let occupancy of getOccupancyPricingsFormArray(packageIndex).controls;index as occupancyIndex" [formGroupName]="occupancyIndex">
                        <td>
                          <div class="pax-container" formGroupName="paxRange">
                            <div [ngClass]="{ 'invalid-input': checkInvalidControl(occupancy, 'paxRange.minRange') || checkInvalidControl(occupancy, 'paxRange') }">
                              <input appNumbersOnly class="input pax-input" placeholder="0" formControlName="minRange">
                            </div>
                            <label for="" class="mx-1">-</label>
                            <div [ngClass]="{ 'invalid-input': checkInvalidControl(occupancy, 'paxRange.maxRange') || checkInvalidControl(occupancy, 'paxRange') }">
                              <input appNumbersOnly class="input pax-input" placeholder="0" formControlName="maxRange" (blur)="maxRangeChanged($event, packageIndex, occupancyIndex)">
                            </div>
                          </div>
                        </td>
                        <td>
                          <div [ngClass]="{ 'invalid-input': checkInvalidControl(occupancy, 'landPax') }">
                            <input appNumbersOnly class="input" placeholder="0" formControlName="landPax">
                          </div>
                        </td>                        
                        <ng-container formGroupName="occupancy">
                          <td>
                            <div [ngClass]="{ 'invalid-input': checkInvalidControl(occupancy, 'occupancy')}">
                              <input appNumbersOnly class="input" placeholder="0" formControlName="sgl">
                            </div>
                          </td>
                          <td>
                            <div [ngClass]="{ 'invalid-input': checkInvalidControl(occupancy, 'occupancy')}">
                              <input appNumbersOnly class="input" placeholder="0" formControlName="dbl">
                            </div>
                          </td>
                          <td>
                            <div [ngClass]="{ 'invalid-input': checkInvalidControl(occupancy, 'occupancy')}">
                              <input appNumbersOnly class="input" placeholder="0" formControlName="tpl">
                            </div>
                          </td>
                        </ng-container>
                        <td>
                          <div [ngClass]="{ 'invalid-input': checkInvalidControl(occupancy, 'childWithBed') }">
                            <input appNumbersOnly class="input" placeholder="0" formControlName="childWithBed">
                          </div>
                        </td>
                        <td>
                          <div [ngClass]="{ 'invalid-input': checkInvalidControl(occupancy, 'extraChildWithoutBed') }">
                            <input appNumbersOnly class="input" placeholder="0" formControlName="extraChildWithoutBed">
                          </div>
                        </td>
                        <td>
                          <div class="">
                            <ion-button fill="clear" color="danger" class="table-action-btn" (click)="removeOccupancyPricing(packageIndex, occupancyIndex)" [disabled]="getOccupancyPricingsFormArray(packageIndex).length <= 1">
                              <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                            </ion-button>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
              <div class="pricing-table-footer">
                <div class="d-flex justify-content-end">
                  <ion-button class="sm-clear-btn" fill="clear" size="small" (click)="addOccupancyPricing(packageIndex)">
                    <ion-icon name="add-outline"></ion-icon> Add Pax
                  </ion-button>
                  <ion-button class="sm-clear-btn" fill="clear" size="small" color="danger" (click)="clearAllOccupancyPricing(packageIndex)">
                    <ion-icon name="close-outline"></ion-icon> Clear All Pax
                  </ion-button>
                  <ion-button class="sm-clear-btn" fill="clear" size="small" color="medium" (click)="removePackage(packageIndex)" *ngIf="getPackagesFormArray().length > 1">
                    <ion-icon name="trash-outline"></ion-icon> Remove Package
                  </ion-button>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="w-100">
          <div class="d-flex justify-content-end">
            <ion-button class="sm-clear-btn" fill="clear" size="small" color="medium" (click)="addPackage()">
              <ion-icon name="add-outline"></ion-icon> Add Package
            </ion-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Pricing notes section -->
    <div class="ion-no-padding my-1">
      <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Notes</ion-title>
    </div>
    <div class="ion-padding-horizontal">
      <div class="row">
        <div class="col-12">
          <div class="input-container">
            <div>
              <app-text-formatting-input formControlName="notes"></app-text-formatting-input>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>

  <div class="ion-padding-horizontal bg-light-gray justify-content-center itinerary-model-footer">
    <ion-button class="unfilled-blue-btn" (click)="goPrevious()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</form>